<template>
    <div>
      <div id="page-title" class="clearfix">
        <h1>Appsy<span>// UM POUCO SOBRE O APPSY.</span></h1>
      </div>

      <div id="content-wrap" class="clearfix">
        <div class="content-wrapper clearfix">
          <div class="entry_content">
            <div class="col_two_third nobottommargin">
              <div class="col_one_third">
                <div class="product-feature2">
                  <img src="../assets/imgs/icons/iphone4.png" alt="Mobilidade" title="Mobilidade" />
                  <h3>Mobilidade</h3>
                  <p>Psiquiatras tem acesso aos dados e reportam atividades quando estão longe do consultório. Atue a qualquer momento, onde estiver.</p>
                </div>
              </div>

              <div class="col_one_third">
                <div class="product-feature2">
                  <img src="../assets/imgs/icons/user-comment.png" alt="Adesão de Pacientes" title="Adesão de Pacientes" />
                  <h3>Adesão de Pacientes</h3>
                  <p>Comunicações com os pacientes são intensificadas, consolidadas e automaticamente documentadas. Isto inclui o envio de resultados de exames.</p>
                </div>
              </div>

              <div class="col_one_third col_last">
                <div class="product-feature2">
                  <img src="../assets/imgs/icons/users2.png" alt="Colaboração" title="Colaboração" />
                  <h3>Colaboração</h3>
                  <p>Psiquiatras poderão designar papéis e tarefas para seus assistentes, residentes e secretárias, agilizando o trabalho conjunto.</p>
                </div>
              </div><div class="clear"></div>

              <div class="col_one_third nobottommargin">
                <div class="product-feature2">
                  <img src="../assets/imgs/icons/ruler.png" alt="Padronização" title="Padronização" />
                  <h3>Padronização</h3>
                  <p>Dentro de cada paciente, existem 9 etapas a serem seguidas, que padronizam a forma de coleta e acompanhamento de cada paciente, desta forma minimizando erros.</p>
                </div>
              </div>

              <div class="col_one_third nobottommargin">
                <div class="product-feature2">
                  <img src="../assets/imgs/icons/medical-case.png" alt="Wizard de Prescrição" title="Wizard de Prescrição" />
                  <h3>Wizard de Prescrição</h3>
                  <p>Uma das primeras funcionalidades inteligentes do Appsy é o módulo de ajuda a prescrição. Através do uso de tags que serão continuamente monitoradas e otimizadas, o módulo dá agilidade, evita erros e documenta a prescrição.</p>
                </div>
              </div>

              <div class="col_one_third nobottommargin col_last">
                <div class="product-feature2">
                  <img src="../assets/imgs/icons/help.png" alt="Suporte" title="Suporte" />
                  <h3>Suporte</h3>
                  <p>Voce e seu time de trabalho contam com suporte via email suporte@orb9.com, e, em breve, poderão adquirir suporte telefônico em horário estendido no plano premium.</p>
                </div>
              </div>
            <div class="clear"></div>
          </div>

          <div class="col_one_third nobottommargin col_last">
            <div class="accordion2 clearfix">
              <div class="acc-title">
                <span>Nossa Missão</span>
              </div>
              <div class="acc-content clearfix">
                Inovar continuamente para oferecer aos Psiquiatras a melhor ferramenta de produtividade e apoio à prática diária.
              </div>

              <div class="acc-title">
                <span>Porque Escolher o Appsy</span>
              </div>
              <div class="acc-content clearfix">
                O Appsy é uma ferramenta criada e guiada por psiquiatras, e operada por uma empresa de tecnologia e negócios.
              </div>

              <div class="acc-title">
                <span>Nossos Pontos Fortes</span>
              </div>
              <div class="acc-content clearfix">
                <div><span>- O Appsy é gratuito para associados da ABP (Associação Brasileira de Psiquiatria).</span></div>
                <div><span>- O Appsy oferece mobilidade. Os dados de seus pacientes sempre com você.</span></div>
                <div><span>- O Appsy é uma solução em continua evolução.</span></div>
                <div><span>- O Appsy permite colaboração e apoia atividades de um médico Preceptor.</span></div>
              </div>

              <div class="acc-title">
                <span>Como contratar o Appsy</span>
              </div>
              <div class="acc-content clearfix">
                O pedido de cadastro deve ser feito pelo próprio Médico na área específica do site:&nbsp;<strong>Registre-se</strong>
              </div>
            </div>
            <div class="clear"></div>
          </div>
          
          <div class="clear"></div>

          <div class="callout clearfix" style="margin-top: 10px;margin-bottom: 30px;">
            <div class="callout-desc">
              <h3>Idealizadores</h3>
            </div>
            <div class="callout-action">
              <a href="https://my.appsy2.com.br" target="_blank" class="imgfade" style="opacity: 1;">Acesse já</a>
            </div>
          </div>

          <div class="col_half nobottommargin">
            <div class="team-member clearfix">
              <div class="tmember-pic">
                <img src="../assets/imgs/Gedergrohs-3-150x150.png" title="Geder Grohs" alt="Geder Grohs">
              </div>

              <div class="tmember-content">
                <h4>Geder Grohs <span>// Idealizador e Consultor Técnico-Médico</span></h4>
                <p>
                  Médico pela Universidade Federal do Rio Grande do Sul, Psiquiatra pela Universidade Complutense de Madrid e Mestre em Informática Médica pela Ciências Médicas da Universidade Federal de Santa Catarina. Atualmente é psiquiatra preceptor do programa de Residência Médica de Psiquiatria do Instituto de Psiquiatria de Santa Catarina / SES-SC, conselheiro técnico voluntário do Grupo Fênix de Santa Catarina e Coordenador do ABP-comunidade e suas mídias sociais.
                  Geder atua como consultor técnico-médico na concepção do Appsy, sendo responsável pela definição e priorização de funcionalidades do serviço.
                </p>

                <div class="clear"></div>

                <div class="tmember-social">
                  <a href="#" title="Twitter" class="ntip">
                    <img src="../assets/imgs/icons/twitter.png" />
                  </a>
                  <a href="http://www.linkedin.com/profile/view?id=80781298" title="LinkedIn" class="ntip">
                    <img src="../assets/imgs/icons/linkedin.png" />
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="col_half nobottommargin col_last">
            <div class="team-member clearfix">
              <div class="tmember-pic">
                <img src="../assets/imgs/ag2-150x150.gif" title="Antonio Geraldo da Silva" alt="Antonio Geraldo da Silva">
              </div>
              <div class="tmember-content">
                <h4>Antonio Geraldo da Silva <span>// Idealizador e Consultor Estratégico</span></h4>
                <p>
                  Médico Psiquiatra da Secretaria de Saúde do Distrito Federal / GDF, Doutoramento pela Faculdade de Medicina da Universidade do Porto – (Portugal) convênio com o Conselho Federal de Medicina., Especialista em psiquiatria pela Associação Brasileira de Psiquiatria - ABP / AMB / CFM, Especialista em Psiquiatria Forense pela Associação Brasileira de Psiquiatria - ABP / AMB - CFM, Diretor Adjunto do Sindicato dos Médicos do Distrito Federal - SINDMÉDICO, Membro da Câmara Técnica de Psiquiatria do Conselho Federal de Medicina - CFM, Editor da Revista ''Debates em Psiquiatria'' e do 'Jornal de Psiquiatria Hoje'. Antônio Geraldo atua como consultor estratégico na concepção do Appsy, sendo responsável pelas definições dos objetivos do serviço para o médico e a sociedade no médio e longo prazo, assim como pelas definições quanto ao posicionamento comercial.
                </p>

                <div class="clear"></div>

                <div class="tmember-social">
                  <a href="#" class="ntip" original-title="Twitter">
                    <img src="../assets/imgs/icons/twitter.png" />
                  </a>
                  <a href="#" class="ntip" original-title="LinkedIn">
                    <img src="../assets/imgs/icons/linkedin.png" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: 'O aplicativo',
  },

  data () {
    return {
      accordionTitles: [],
    }
  },

  mounted () {
    this.accordionTitles = document.querySelectorAll('.accordion2 .acc-title')

    this.accordionTitles.forEach(accordionButton => {
      accordionButton.addEventListener('click', function() {
        this.nextElementSibling.classList.toggle('visible')
        this.classList.toggle('acc-titlec')
      })
    })
  },
}
</script>

<style lang="stylus">
  .accordion2 .acc-content
    display: none

    &.visible
      display: block
</style>
